/** How often server state refetches while the page is in use (main.tsx). */
export const REFETCH_INTERVAL_MS = 30_000;
